let cookieName = 'menu_collapsed';

let sidebar = (event) => {

    let target;
    if (target = event.target.closest('#vut-menu-wrap #vut-menu-lock')) {
        let r = new RegExp('^' + cookieName + '=');
        let cookie = parseInt((document.cookie.split(';').map(c => c.trim()).find((c) => r.test(c)))?.split('=')?.[1] ?? 0) || 0;

        document.cookie = cookieName + '=' + (cookie ? 0 : 1) + '; expires=' + (new Date(new Date().getTime() + 5184000000).toUTCString()) +'; path=/';

        target.closest('#vut-menu-wrap').classList[cookie ? 'remove' : 'add']('vut-menu-collapsed');
        target.dataset.bsTitle = cookie ? window.jstr('Skrývat menu') : window.jstr('Neskrývat menu');
        // bootstrap.Tooltip(target)
        let span = target.querySelector('span');
        if (span) {
            span.className = cookie ? 'icon-indent-decrease2' : 'icon-indent-increase2';
        }

        document.querySelector('.vut-footer')?.classList?.[cookie ? 'remove' : 'add']?.('vut-footer-collapsed');
        window.initBootstrap?.('#vut-menu-wrap');
        // fix dotyková zařízení visící tooltipy //
        setTimeout(()=>document.querySelectorAll('.tooltip ').forEach(e=>e.remove()), 50);

        window.VUTResizeHandler?.dispatch?.();

    }

}

window.addEventListener('DOMContentLoaded', ()=>{

    if (!document.querySelector('#vut-menu-wrap')) return;
    cookieName = document.querySelector('#vut-menu-wrap')?.dataset?.cookieName || cookieName;
    document.addEventListener('click', sidebar, true);

    // vyvolání resize při rozbalení/zabalení menu na mobilu //
    let i, t;
    window.addEventListener('transitionstart', (event)=>{
        if (event.target.matches('.collapsing')) {
            clearInterval(i);
            // nejde dát míň, 50 je timeout v handleru //
            i=setInterval(window.VUTResizeHandler?.dispatch, 55);
            // záchranná brzda, kdyby se transitionend nějak nepovedl, už se to povedlo...
            clearTimeout(t);
            t=setTimeout(clearInterval.bind(window, i), 750);
        }
    });
    window.addEventListener('transitionend', (event)=>{
        if (event.target.matches('.collapse')) {
            window.VUTResizeHandler?.dispatch?.()
            clearInterval(i)
            clearTimeout(t);
        }
    });

    // prevent kliku z mobilu na odkaz ve sbaleném sidebaru + vynucení rozbalení sidebaru po touch //
    window.addEventListener('touchstart', (event)=>{
        if (event.target.closest('.vut-menu-collapsed')) {
            if (event.target.closest(' #vut-menu :is(a, button)') && (event.target.closest('.vut-menu-collapsed #vut-menu').offsetWidth < 48)) {
                event.target.style.pointerEvents = 'none';
                setTimeout(() => event.target.style.pointerEvents = '', 500);
            }
            event.target.closest('.vut-menu-collapsed').classList.add('--touched');
        } else {
            document.querySelector('.vut-menu-collapsed.--touched')?.classList?.remove?.('--touched');
        }
    }, true)

})
